import { API } from '@/modules/api'

export function getAgreementsRegulation () {
  return new API().getRodoRegulationsContent()
}


// WEBPACK FOOTER //
// ./src/services/RodoRegulations.js